import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { platformApiFetch } from '../../api/client';

export const ADDONS_QUERY_KEY = ['platform', 'addons'];

export function useAddons() {
  return useQuery({
    queryKey: ADDONS_QUERY_KEY,
    queryFn: () => platformApiFetch('/api/platform/addons'),
  });
}

export function useCreateAddon() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      platformApiFetch('/api/platform/addons', {
        method: 'POST',
        body,
        errorMessage: 'Failed to create addon',
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ADDONS_QUERY_KEY }),
  });
}

export function useUpdateAddon(uuid) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      platformApiFetch(`/api/platform/addons/${uuid}`, {
        method: 'PATCH',
        body,
        errorMessage: 'Failed to update addon',
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ADDONS_QUERY_KEY }),
  });
}

export function useSyncAddon(uuid) {
  return useMutation({
    mutationFn: () =>
      platformApiFetch(`/api/platform/addons/${uuid}/sync-abacatepay`, {
        method: 'POST',
        errorMessage: 'Failed to sync addon',
      }),
  });
}
